var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-col p-3" },
        [
          _c(
            "div",
            { staticClass: "pb-3 flex justify-between items-center w-full" },
            [
              _c(
                "el-row",
                { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "search album name" },
                        on: { change: _vm.searchAlbum },
                        model: {
                          value: _vm.filters,
                          callback: function($$v) {
                            _vm.filters = $$v
                          },
                          expression: "filters"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "flex items-center", attrs: { span: 6 } },
                    [
                      _c("Button", {
                        attrs: { label: "Apply" },
                        on: { clicked: _vm.searchAlbum }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "p-2" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "sync"] },
                            on: { click: _vm.resetAlbum }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "flex justify-end", attrs: { span: 12 } },
                    [
                      _c("Button", {
                        attrs: {
                          label: "Add Album",
                          variant: "outline-primary"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.isShowModalAdd = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "pb-3 w-full" },
            [
              _c(
                "el-col",
                { staticClass: "flex flex-row gap-3", attrs: { span: 24 } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "md:w-50 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 0
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 0
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Waiting For Review (" +
                                  _vm._s(_vm.countWaitingForReviewAlbumArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: " md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 1
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 1
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Under Review (" +
                                  _vm._s(_vm.countUnderReviewAlbumArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 2
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 2
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium" },
                            [
                              _vm._v(
                                "\n              Approved (" +
                                  _vm._s(_vm.countApprovedAlbumArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 3
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 3
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium " },
                            [
                              _vm._v(
                                "\n              Rejected (" +
                                  _vm._s(_vm.countRejectedAlbumArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "md:w-40 ",
                      on: {
                        click: function($event) {
                          _vm.filterStatus = 4
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                          class:
                            _vm.filterStatus == 4
                              ? "bg-indigo-500 text-gray-100"
                              : ""
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "m-auto text-xs font-medium " },
                            [
                              _vm._v(
                                "\n              Published (" +
                                  _vm._s(_vm.countPublishedAlbumArtist) +
                                  ")\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "data-tables-server",
            {
              ref: "tableAlbum",
              attrs: {
                data: _vm.data,
                total: _vm.total,
                "pagination-props": { background: true, pageSizes: [20] }
              },
              on: { "query-change": _vm.onChangeTable }
            },
            [
              _vm._l(_vm.titles, function(title) {
                return _c("el-table-column", {
                  key: title.prop,
                  attrs: {
                    prop: title.prop,
                    label: title.label,
                    sortable: "custom"
                  }
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                staticClass: "text-center",
                attrs: { label: "Publish" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.published
                                ? "Published"
                                : "Not Published"
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Actions", "min-width": "100px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "static inline-block text-left container-action"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "rounded-md shadow-sm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "py-1" },
                                  [
                                    _c(
                                      "VueCustomTooltip",
                                      {
                                        attrs: {
                                          label: "See Detail",
                                          position: "is-right"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                            on: {
                                              click: function($event) {
                                                return _vm.detail(
                                                  $event,
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "text-white",
                                              attrs: { icon: ["fa", "eye"] }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "VueCustomTooltip",
                                      {
                                        attrs: {
                                          label: "Edit",
                                          position: "is-left"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none",
                                            on: {
                                              click: function($event) {
                                                _vm.isShowModalEdit = true
                                                _vm.idAlbum = scope.row.id
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass: "text-white",
                                              attrs: {
                                                icon: ["fa", "pencil-alt"]
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          attrs: {
            isShowingModal: _vm.isShowingModalDetail,
            isLoading: _vm.isLoading,
            title: "Album Details",
            size: "xlarge"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalDetail = !_vm.isShowingModalDetail
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("DetailAlbum", {
                attrs: {
                  "toggle-reset": _vm.isShowingModalDetail,
                  "album-id": _vm.idAlbum
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addAlbumModal",
          attrs: {
            isShowingModal: _vm.isShowModalAdd,
            "label-submit": "Submit",
            title: "Add Album"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowModalAdd = !_vm.isShowModalAdd
            },
            save: function($event) {
              return _vm.submit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("AddAlbum", {
                ref: "addAlbum",
                attrs: {
                  "toggle-reset": _vm.isShowModalAdd,
                  "user-id": _vm.artistid,
                  "musicverse-cut": _vm.musicverseCut,
                  "artist-cut": _vm.artistCut
                },
                on: { "on-submit-album": _vm.onSubmitAlbum }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "EditAlbumModal",
          attrs: {
            isShowingModal: _vm.isShowModalEdit,
            "label-submit": "Save",
            title: "Edit Album"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowModalEdit = !_vm.isShowModalEdit
            },
            save: function($event) {
              return _vm.submitEdit()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("EditAlbum", {
                ref: "editAlbum",
                attrs: {
                  "toggle-reset": _vm.isShowModalEdit,
                  "album-id": _vm.idAlbum,
                  "musicverse-cut": _vm.musicverseCut,
                  "artist-cut": _vm.artistCut
                },
                on: { "on-edit-album": _vm.onSubmitEditAlbum }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d21798e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d21798e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist/ListAlbum.vue
// module id = null
// module chunks = 